module.exports = __webpack_public_path__ + "images/background_overlay@2x.png?de94db91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_overlay@2x.png
// module id = 601
// module chunks = 7